import { c as _c } from "react/compiler-runtime";
import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import { Shimmer } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import SecuredByFootprint from '../../secured-by-footprint';
import LanguageSelect from './language-select';
import SupportLinksSelect from './support-links-select';
type FootprintFooterProps = {
  config?: OnboardingSessionConfig;
  className?: string;
  hideSoc?: boolean;
  id?: string;
};
const Footer = forwardRef<HTMLDivElement, FootprintFooterProps>((t0, ref) => {
  const $ = _c(22);
  const {
    config,
    className,
    hideSoc,
    id
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "global.components.footer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  const shouldShowSupportLinks = config?.supportEmail || config?.supportPhone || config?.supportWebsite;
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = config?.privacyPolicyUrl ?? "https://onefootprint.com/privacy-policy";
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      label: t2,
      href: t3
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t(_temp2);
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = config?.termsOfServiceUrl ?? "https://onefootprint.com/terms-of-service";
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = {
      label: t5,
      href: t6
    };
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t7) {
    t8 = [t4, t7];
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const links = t8;
  let t9;
  if ($[14] !== className || $[15] !== config || $[16] !== hideSoc || $[17] !== id || $[18] !== links || $[19] !== ref || $[20] !== shouldShowSupportLinks) {
    t9 = config ? <footer id={id} ref={ref} className={cx("flex items-center justify-between px-4 h-10", {
      "justify-center": !config.showFootprintLogo,
      "justify-between": config.showFootprintLogo
    }, className)}>{config.showFootprintLogo && <SecuredByFootprint />}<div className="flex items-center justify-center gap-3">{shouldShowSupportLinks && <SupportLinksSelect config={config} />}{links.map(_temp3)}<LanguageSelect />{hideSoc ? null : <div><img src="/footer/soc-2-badge.png" height={32} width={32} alt="Soc2 badge" /></div>}</div></footer> : <Shimmer height="50px" width="100%" />;
    $[14] = className;
    $[15] = config;
    $[16] = hideSoc;
    $[17] = id;
    $[18] = links;
    $[19] = ref;
    $[20] = shouldShowSupportLinks;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
});
export default Footer;
function _temp($) {
  return $.links.privacy;
}
function _temp2($_0) {
  return $_0.links.terms;
}
function _temp3(t0) {
  const {
    href,
    label
  } = t0;
  return <a className="no-underline text-secondary hover:underline hover:underline-offset-2 hover:decoration-2 inline-block text-caption-1" href={href} key={label} rel="noreferrer" target="_blank">{label}</a>;
}